import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { addParametersToUri } from 'nallian-shared-ui/lib/lib/uri';
import HasRight from 'nallian-shared-ui/lib/layout/rights/HasRight';
import { Link, Button } from 'nallian-shared-ui/lib/components';
import { Table, Actions, Params, Menu } from 'nallian-table-builder-ui';
import { INFINITE_SCROLL, RELATIONS_RESOURCE, COMMUNITY_TAB_ACTIONS } from '../../constants';
import NewRelation from './NewRelation';
import apiRoutes from '../../../../app/api/routes';
import CommunityMemberFilter from './filter/CommunityMemberFilter';
import TableValue from './table/TableValue';

const RelationsOverview = ({ communityId, rootUrl }) => {
  const { t } = useTranslation();
  const { id: paramsId, action, actionId } = useParams();

  const id = communityId || paramsId;

  return (
    <>
      <HasRight right="RELATIONS.MANAGE.ALL">
        <NewRelation open={id && action && !actionId} communityId={id} rootUrl={rootUrl} />
        <Link to={`${rootUrl}/${COMMUNITY_TAB_ACTIONS.NEW_RELATION}`}>
          <Button btnprimary icon="plus" content={t('newRelation')} />
        </Link>
      </HasRight>
      <Table
        url={addParametersToUri(apiRoutes.relations(), { communityId: id })}
        infiniteScroll={INFINITE_SCROLL}
        resource={RELATIONS_RESOURCE}
        pageSize={50}
        noUserSettings
        resizable
        filtered
        sorted
      >
        <Params.Custom
          grow
          name="source.name"
          label="source"
          width="16rem"
          minWidth="16rem"
          filterName="sourceId"
          content={TableValue}
          communityId={communityId}
          filter={CommunityMemberFilter}
        />
        <Params.String
          grow
          name="relationType.name"
          label="relationType"
          width="16rem"
          minWidth="16rem"
        />
        <Params.Custom
          grow
          name="target.name"
          label="target"
          width="16rem"
          minWidth="16rem"
          filterName="targetId"
          content={TableValue}
          communityId={communityId}
          filter={CommunityMemberFilter}
        />
        <Menu width="3.5rem" align="center" hasRight="RELATIONS.MANAGE.ALL">
          <Actions.Delete
            url={apiRoutes.relations(':id')}
            confirmMessage={t('areYouSureRemoveRelation')}
          />
        </Menu>
      </Table>
    </>
  );
};

RelationsOverview.propTypes = {
  rootUrl: PropTypes.string.isRequired,
  communityId: PropTypes.string,
};

RelationsOverview.defaultProps = { communityId: undefined };

export default RelationsOverview;
